import { z } from 'zod';
import { ParticipantProfileSchema, notificationPreferences } from './entity';
import { PagingSchema } from '../shared/paging';

export const GetParticipantProfileResponseSchema = ParticipantProfileSchema;

export type GetParticipantProfileResponse = z.infer<
  typeof GetParticipantProfileResponseSchema
>;

export const UpdateParticipantPreferencesSchema = z.object({
  notificationPreference: z.enum(notificationPreferences),
  phone: z
    .string()
    .regex(/^\+[1-9]\d{1,15}$/)
    .optional(),
});

export type UpdateParticipantPreferences = z.infer<
  typeof UpdateParticipantPreferencesSchema
>;

export const ListParticipantSchema = PagingSchema.extend({
  email: z.string().min(3).optional(),
});

export type ListParticipant = z.infer<typeof ListParticipantSchema>;
